export default __webpack_public_path__ + "static/media/payment-check-mobile.cf9ce4fd.svg";